var utils = require("./utils");

var $srcElement = $(this);
var $hiddenInput = $(".js-sap-vendor-codes");

var vendorCodeObject = {};

var objCounter = 0;

var $content = $("#sap_vendor_codes_table").children("tbody");

function isInOrganisationPage() {
  return $("#organisation-page").length > 0;
}

//        $srcElement.find('.js-add').click(addClickEvent);

if (isInOrganisationPage()) {
  //                    $srcElement.find('.js-add').click(addClickEvent);
  $("#tradingPartnerId").keypress(function (e) {
    if (this.value.length == 10) {
      return false;
    }
  });

  $("#sap_vendor_code").keypress(function (e) {
    if (this.value.length == 10) {
      return false;
    }
  });

  $(".js-add").on("click", function (event) {

    if (!isThereVendorCodeConflict()) {
      var newDataObject = getDataInput();
      if (newDataObject) {
        addToVendorCodeObject(newDataObject);
        renderContent();
        updateHiddenInput();
        resetInputs();
      }
    }
  });
  storeExistingDomContent();
  renderContent();
  updateHiddenInput();
  //                    updateSelect();

}

function addClickEvent(e) {}

function getDataInput() {
  //            var orgElement = $srcElement.find(':selected');
  //            console.log("when selected");
  //            var orgId = $("#orgName").val();
  //            console.log(orgId);
  var sapVendorCodeType = $("#sap_vendor_codes_type option:selected").text();

  var sapVendorCode = $("#sap_vendor_code").val();
  //        var date = $srcElement.find(':text').not(':hidden').val();

  var obj = {};

  if (sapVendorCodeType !== "" && sapVendorCode !== "") {
    obj[sapVendorCodeType] = {};
    obj[sapVendorCodeType] = sapVendorCode;

    //            $('#orgName').empty();
    //            console.log($('#orgName').val());
    //            console.log($("#orgName option:selected").empty().append('<option selected="selected" value="whatever">text</option>'));
    return obj;
  }

  return false;
}

function addToVendorCodeObject(obj) {
  $.extend(vendorCodeObject, obj);
}

function renderContent() {
  $("#sap_vendor_codes_table").children("tbody").replaceWith(getTbody());
}

function updateHiddenInput() {
  $hiddenInput.val(JSON.stringify(mapObject(vendorCodeObject)));
}

function getExistingDomContent() {
  var obj = {};
  $($content)
    .find("tr")
    .each(function () {
      //            var id = $(this).attr('id');
      //            console.log("in getExistingDomMethod, id--"+id);
      var $td = $("td", this);

      //            obj[sapVendorCode] = $td.eq(0).text();

      var index = $td.eq(0).text();
      obj[index] = $td.eq(1).text();
    });

  return obj;
}

function mapObject(data) {
  var obj = [];

  for (var key in data) {
    var item = {};
    item.type = key;
    item.value = data[key];
    obj.push(item);
  }

  return obj;
}

function resetInputsReference() {
  $($srcElement.find(":text").not(":hidden")).val("");

  var orgText = $("#orgName option:selected").text();
  var orgValue = $("#orgName option:selected").val();
  var newOrg = $('<option value="' + orgValue + '">' + orgText + "</option>");
  $("#orgName option:selected").empty();
  $("#orgName").append(newOrg);
  $("#orgName").trigger("chosen:updated");

  var reasonText = $("#extensionReason option:selected").text();
  var reasonValue = $("#extensionReason option:selected").val();
  var newReason = $(
    '<option value="' + reasonValue + '">' + reasonText + "</option>",
  );
  $("#extensionReason option:selected").empty();
  $("#extensionReason").append(newReason);
  $("#extensionReason").trigger("chosen:updated");
}
function resetInputs() {
  var newVendorCodeTypeText = $(
    "#sap_vendor_codes_type option:selected",
  ).text();
  var newVendorCodeTypeValue = $(
    "#sap_vendor_codes_type option:selected",
  ).val();
  var newVendorCodeType = $(
    '<option value="' +
      newVendorCodeTypeValue +
      '">' +
      newVendorCodeTypeText +
      "</option>",
  );

  $("#sap_vendor_codes_type option:selected").empty();
  $("#sap_vendor_codes_type").append(newVendorCodeType);
  $("#sap_vendor_codes_type").trigger("chosen:updated");
  $("#sap_vendor_code").val("");
}

function getTbody() {
  var obj = vendorCodeObject;
  var $content = $("<tbody />");

  var $link;

  $.each(obj, function (key, value) {

    $link = $(
      '<td class="govuk-table__cell"><button class="js-remove" data-vendorcodeid="' +
        key +
        '">remove</button></td>',
    ).on("click", removeClickEvent);
    //
    var $row = $('<tr class="govuk-table__row"/>')
      .append('<td class="govuk-table__cell">' + key + "</td>")
      .append('<td class="govuk-table__cell">' + obj[key] + "</td>")
      .append($link);
    //
    $content.append($row);
    //
  });

  return $content;
}

function removeClickEvent(e) {
  removeFromSapVendorCodeObject($(e.target).data("vendorcodeid"));
  renderContent();
  updateHiddenInput();
}

function removeFromSapVendorCodeObject(key) {
  delete vendorCodeObject[key];
}

function storeExistingDomContent() {
  var obj = getExistingDomContent();
  addToVendorCodeObject(obj);
}

//              $('.js-remove').on('click', function (e) {
//                          console.log('remove called');
////                                       removeFromSapVendorCodeObject($(e.target).data('vendorCodeId'));
////                                                              renderContent();
////                                                              updateHiddenInput();
//                                      });

//                                 function removeFromSapVendorCodeObject(key) {
//                                       delete vendorCodeObject[key];
//                                   }

function isThereVendorCodeConflict() {
  var conflictFlag = false;

  //{7-series: "55555", C-series: "66666"}
  var sapVendorCodeType = $("#sap_vendor_codes_type option:selected").text();

  if (
    sapVendorCodeType.toLowerCase().indexOf("payments") != -1 ||
    sapVendorCodeType.toLowerCase().indexOf("receipts") != -1
  ) {
    // there should not be something without payment or receipt
    $.each(vendorCodeObject, function (key, data) {
      if (
        sapVendorCodeType
          .substr(0, sapVendorCodeType.lastIndexOf("-"))
          .toLowerCase() == key.toLowerCase()
      )
        conflictFlag = true;
    });
  } else {
    // there should not be something with payment or receipt
    $.each(vendorCodeObject, function (key, data) {
      if (
        key.toLowerCase().indexOf(sapVendorCodeType.toLowerCase()) != -1 &&
        (key.toLowerCase().indexOf("payments") != -1 ||
          key.toLowerCase().indexOf("receipts") != -1)
      )
        conflictFlag = true;
    });
  }
  return conflictFlag;
}
